<style>
/* #app {
  overflow: hidden;
} */
[v-cloak] {
  display: none !important;
}
</style>

<template>
  <div id="app">
    <header-common :pageName="currentPage" :NavList="NavList" v-if="type" :class="{'media_small_hide media_big_hide':fromSource=='app'}" v-cloak></header-common>
    <!-- <header-common :pageName="currentPage"></header-common> -->
    <router-view :class="{'common_padding_top':fromSource!='app'}" v-if="children != null"/>
    <footer-common v-if="type" :class="{'media_small_hide media_big_hide':fromSource=='app'}" v-cloak></footer-common>
    <suspen-kr :class="{'media_small_hide media_big_hide':fromSource=='app'}"></suspen-kr>
  </div>
</template>

<script>
import headerCommon from './components/header-common'
import footerCommon from './components/footer-common'
import suspen from './components/suspen'
import common from "./api/common";
export default {
  name: 'App',
  components:{
    headerCommon,
    footerCommon,
    suspenKr: suspen
  },
  data(){
    return{
      fromSource:'',
      Blacklist: [
        'assignmentQuery',
        'replenishProof',
        'recruitModule',
        'qr-code'
      ],
      type: false,
      children: null,
      NavList: []
    }
  },
  computed: {
      currentPage() {
        return this.$route.meta.page;
      },
  },
  methods:{
    isMobile() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
        var flag = false;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) >= 0) {
                flag = true;
                break;
            }
        }
        this.$store.dispatch('user/saveIsMobile',flag)
        return flag;
    },
    getNav() {
      common.getNav().then((res) => {
        this.NavList = res.data;
        this.$store.dispatch("user/saveNavList", JSON.stringify(res.data));
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          if (this.$route.path.indexOf(element.routerName) != -1) {
            let children = element.children ? JSON.stringify(element.children) : '';
            this.$store.dispatch("user/saveChildren", children);
            this.children = element.children ? JSON.stringify(element.children) : '';
            let arr = element.children ? element.children : [];
            for (let j = 0; j < arr.length; j++) {
              const row = arr[j];
              if (row.routerName.indexOf(this.$route.name) != -1) {
                this.$store.dispatch("user/saveCategoryId", row.id);
                this.$store.dispatch("user/saveShedPath", row.routerPath);
              }
            }
          }
        }
      });
    }
  },
  watch: {
    '$route' (to, from) {
      if(this.$route.query.from){   //判断是否是app上用的页面
        this.fromSource = this.$route.query.from;
      }
      this.type = this.Blacklist.indexOf(this.$route.name) == -1;
    }
  },
  created(){
    this.isMobile();
    this.getNav();
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue